var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 10 10",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.29697808 4.96397436 4.59358974-4.59358974c.08461539-.08461539.08461539-.22205129 0-.30692308-.08487179-.08461539-.22230769-.08461539-.30692307 0l-4.59358975 4.59358974-4.59358974-4.59358974c-.08461538-.08461539-.22205128-.08461539-.30692308 0-.08461538.08487179-.08461538.22230769 0 .30692308l4.59358975 4.59358974-4.59358975 4.59358974c-.08461538.08461539-.08461538.22205128 0 .30692308.04256411.04230769.09794872.06358974.15358975.06358974.05538461 0 .11102564-.02128205.15333333-.06358974l4.59358974-4.59358974 4.59358975 4.59358974c.04230769.04230769.09794872.06358974.15333333.06358974.05564103 0 .11128205-.02128205.15358974-.06358974.08461539-.0848718.08461539-.22230769 0-.30692308z",
    fill: "#f00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ae672d0b292ff08c96f0be2b5aa370b3.svg";
export { ForwardRef as ReactComponent };